import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Canvas2Component } from 'src/app/AppBaseComponents/canvas2/canvas2.component';
import { ListInterface } from '../../Inteface/list-interface';
import { ActionModel } from '../../Models/action-model';
import { CTVModel } from '../../Models/ctv-model';
import { StepModel } from '../../Models/step-model';
import { WebObjectModel } from '../../Models/web-object-model';
import { ActionServiceService } from '../../Services/action-service.service';
import { CTVService } from '../../Services/ctv.service';
import { NotifyService } from '../../Services/notify.service';
import { PageServiceService } from '../../Services/page-service.service';
import { SharedService } from '../../Services/shared.service';
import { StepServiceService } from '../../Services/step-service.service';
import { TargetObjectService } from 'src/app/Services/target-object.service';


@Component({
  selector: 'ze-step-view',
  templateUrl: './step-view.component.html',
  styleUrls: ['./step-view.component.scss']
})
export class StepViewComponent implements OnInit {
  @ViewChild('canvasRef', { static: false }) canvas: Canvas2Component;
  webpages: any;
  currentWebPage: string;
  stepId: string;
  currentStep: StepModel;
  @Input("stepIdInput") stepIdInput: string;
  public targetobjectListInterface: ListInterface;
  public actionListInterface: ListInterface;
  public ctvList: CTVModel[];
  public loaderCounter: number = 0;
  @Input("showSaveButton") showSaveButton: boolean = true;
  @Input("rightLeftPanel") rightLeftPanel: boolean = true;
  @Input("modifyStep") modifyStep: boolean;
  @Output("hideStep") hideStep = new EventEmitter();
  @Output("modifyEvent") modifyEvent = new EventEmitter();
  @Output("stepSaved") stepSaved = new EventEmitter();
  constructor(
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private stepService: StepServiceService,
    private targetObjectService: TargetObjectService,
    private actionService: ActionServiceService,
    private pageServices: PageServiceService,
    private cTVService: CTVService,
    private notifys: NotifyService,
    private _sharedService: SharedService,
  ) {
    this.targetobjectListInterface = new ListInterface();
    this.targetobjectListInterface.mainHeadingName = "Objects";
    this.targetobjectListInterface.setOnclick(this, "onTargetObjectSelected");
    this.getRouteParams();
    this.actionListInterface = new ListInterface();
    this.actionListInterface.mainHeadingName = "Actions";
    this.actionListInterface.setOnclick(this, "onActionSelected");
    this.getActions();
    this.getWebPages();
  }

  ngOnInit() { }
  ngOnChanges(changes: SimpleChanges) {
    this.stepIdInput = changes.stepIdInput.currentValue;
    this.stepId = null;
    this.getStepItemsdb2();
  }
  getStepItems() {
    this._sharedService.loaderHide.emit(true)
    this.cTVService.getItemsByStep(this.stepId).subscribe(data => {
      this.ctvList = data['data'];
      this._sharedService.loaderHide.emit(false)
    });
  }
  getStepItemsdb2() {
    if (this.stepId)
      return;
    this.getStepdb2();
    this._sharedService.loaderHide.emit(true)
    this.cTVService.getItemsByStepdb2(this.stepIdInput).subscribe(data => {
      this.ctvList = data['data'];
      this._sharedService.loaderHide.emit(false)
    });
  }
  getActions() {
    this._sharedService.loaderHide.emit(true)
    this.loaderCounter++;
    this.actionService.getItems().subscribe((data) => {
      this.actionListChange(data['data'].filter(Boolean));
      this.loaderCounter--;
      if (this.loaderCounter == 0)
        this._sharedService.loaderHide.emit(false);
    })
  }

  refreshWebPageObjects() {
    if(this.currentWebPage != undefined || this.currentWebPage != null) {
      this.getTargetObjects();
    }
  }

  getTargetObjects() {
    this._sharedService.loaderHide.emit(true)
    this.loaderCounter++;
    var page_id = this.currentWebPage;
    if(page_id != undefined && page_id != null) {
      if (this.router.url.includes('/canvas')) {
        this.targetObjectService.getObjectsdb2(page_id).subscribe(data => {
          this.targetObjectListChange(data['data'].filter(Boolean));
          this.loaderCounter--;
          if (this.loaderCounter == 0)
            this._sharedService.loaderHide.emit(false)
        });
        return;
      }
      this.targetObjectService.getObjects(page_id).subscribe(data => {
        this.targetObjectListChange(data['data'].filter(Boolean));
        this.loaderCounter--;
        if (this.loaderCounter == 0)
          this._sharedService.loaderHide.emit(false)
      });
    }
  }
  getStep() {
    this._sharedService.loaderHide.emit(true);
    this.loaderCounter++;
    this.stepService.findById(this.stepId).subscribe((data) => {
      this.currentStep = data['data'];
      this.loaderCounter--;
      if (this.currentStep == null) this.router.navigate(['404']);
      if (this.loaderCounter == 0)
        this._sharedService.loaderHide.emit(false)
    });
  }
  getStepdb2() {
    this._sharedService.loaderHide.emit(true);
    this.loaderCounter++;
    this.stepService.findByIddb2(this.stepIdInput).subscribe((data) => {
      this.currentStep = data['data'];
      this.loaderCounter--;
      if (this.currentStep == null) this.router.navigate(['404']);
      if (this.loaderCounter == 0)
        this._sharedService.loaderHide.emit(false)
    });
  }
  getRouteParams() {
    this.activatedRoute.params.subscribe(params => {
      this.stepId = params.stepId;
      if (this.stepId) {
        this.getStepItems();
        this.getStep();
      }
    });
  }
  targetObjectListChange(models: any[]) {
    this.targetobjectListInterface.models = models;
  }
  onTargetObjectSelected(model) {
  }
  actionListChange(models: ActionModel[]) {
    this.actionListInterface.models = models;
  }
  onActionSelected(model: ActionModel) {
  }
  changePage(value) {
    this.currentWebPage = value;
    this.getTargetObjects();
  }
  getWebPages() {
    if (this.router.url.includes('/canvas')) {
      this.loaderCounter++;
      this._sharedService.loaderHide.emit(true);
  
      // Get pages from '/canvas' with green background
      this.pageServices.getdb2Items().subscribe(data => {
        this.webpages = data['data'].filter(Boolean).map(page => ({ ...page, color: 'darksalmon' }));
        this.pageServices.getItems().subscribe(data => {
          // Concatenate pages from other sources with red background
          this.webpages = this.webpages.concat(data['data'].filter(Boolean).map(page => ({ ...page, color: 'wheat' })));
          this.loaderCounter--;
          if(this.currentWebPage != undefined || this.currentWebPage != null) {
            this.getTargetObjects();
          }

          if (this.loaderCounter == 0)
            this._sharedService.loaderHide.emit(false);
        });
      });
      return;
    }
  
    this.loaderCounter++;
    this._sharedService.loaderHide.emit(true);
  
    // Get pages from other sources with red background
    this.pageServices.getItems().subscribe(data => {
      this.webpages = data['data'].filter(Boolean).map(page => ({ ...page, color: 'wheat' }));
      this.loaderCounter--;
      if(this.currentWebPage != undefined || this.currentWebPage != null) {
        this.getTargetObjects();
      }

      if (this.loaderCounter == 0)
        this._sharedService.loaderHide.emit(false);
    });
  }
  updateCanvas(eve) {
    if (this.isValidated(eve) && this.getInValidCommandSteps(eve).length == 0) {
      this._sharedService.loaderHide.emit(true)
      if (this.router.url.includes('/canvas')) {
        this.cTVService.addNewdb2(this.stepIdInput, eve).subscribe(data => {
          this._sharedService.loaderHide.emit(false);
          this.getStepItemsdb2();
          this.notifys.notify('success', 'Success', 'Step updated Successfully');
        });
        return;
      }
      this.cTVService.addNew(this.stepId, eve).subscribe(data => {
        this._sharedService.loaderHide.emit(false);
        this.getStepItems();
        this.notifys.notify('success', 'Success', 'Step updated Successfully');
      });
    }
    else {
      // this.canvas.validateCTV();

      // this.notifys.notify('error', 'Please Validate First', 'please validate the Scenraio first');
    }

  }
  delete_bak(event) {
    this._sharedService.loaderHide.emit(true)
    this.cTVService.delete(event).subscribe(data => {
      this._sharedService.loaderHide.emit(false)
      this.getStepItems();
      this.notifys.notify('warning', 'Deleted!', 'Command Step deleted Successfully');
    });
  }
  delete(event) {
    for (let i = 0; i < this.ctvList.length; i++) {
      if (this.ctvList[i]._id == event._id) {
        this.ctvList[i].deleted = 1;
      }
    }
  }
  modifyStepEvent(event) {
    this.rightLeftPanel = event;
    this.modifyEvent.emit(event);
  }
  hideStepfn(event) {
    this.hideStep.emit(event);
  }
  saveAs(data) {
    
    if (this.isValidated(data.commandSteps) && this.getInValidCommandSteps(data.commandSteps).length == 0)
      // if data has no errors in any command steps then 
      this.stepService.saveStep(data).subscribe(data => {
        this.hideStep.emit(event);
        this.stepSaved.emit(true);
        this.notifys.notify('success', 'Saved to Library', 'will be removed from step list');
      })
    else{
      // this.canvas.validateCTV();
      // this.notifys.notify('error', 'Please Validate First', 'please validate the Scenraio first');
    }


  }
  getInValidCommandSteps(commandSteps: CTVModel[]): CTVModel[] {
    return commandSteps.filter((ctv: CTVModel) => {
      if (ctv.errors && Object.keys(ctv.errors).length != 0) {
        return ctv
      }
    });
  }
  isValidated(commandSteps: CTVModel[]): boolean {
    return commandSteps.filter((ctv: CTVModel) => {
      if (!ctv.errors) {
        return ctv
      }
    }).length == 0;
  }
}